import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { Button, toast } from "@devhop/ui";
import { useNavigate, useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useDeleteRoom, useRoomQuery, useUpdateRoom } from "../api/queries";
import { RoomForm } from "../ui/rooms/RoomForm";

export function RoomEditPage() {
  const nav = useNavigate({
    from: "/app/master/rooms/$id/edit",
  });
  const { id } = useParams({ from: "/app/master/rooms/$id/edit" });
  const { data, ...result } = useRoomQuery(id);
  const updateRoom = useUpdateRoom(id);
  const deleteRoom = useDeleteRoom();

  const room = data;

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຫ້ອງຮຽນ", to: "/app/master/rooms" },
            { label: "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ແກ້ໄຂຫ້ອງຮຽນ
            </h2>
            <p className="text-muted-foreground">ປັບປຸງລາຍລະອຽດຂອງຫ້ອງຮຽນ.</p>
          </div>

          <div className="flex gap-2">
            <Button
              variant="destructive"
              onClick={async () => {
                const ok = await import("@devhop/ui").then((m) =>
                  m.confirm({
                    title: "ລຶບຫ້ອງຮຽນ",
                    description: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະລຶບຫ້ອງຮຽນນີ້?",
                    actionText: "ລຶບ",
                    ActionProps: {
                      variant: "destructive",
                    },
                  }),
                );
                if (!ok) return;

                try {
                  await toast.promise(deleteRoom.run(id), {
                    loading: "ກຳລັງລຶບ...",
                    success: () => {
                      nav({ to: "/app/master/rooms" });
                      return "ລຶບຫ້ອງຮຽນສຳເລັດ";
                    },
                    error: "ລຶບຫ້ອງຮຽນລົ້ມເຫຼວ",
                  });
                } catch (error) {
                  // Error handling is done by toast.promise
                }
              }}
            >
              ລຶບ
            </Button>
            <Button
              variant="outline"
              onClick={() => nav({ to: "/app/master/rooms" })}
            >
              <ArrowLeftIcon className="size-4" />
              ກັບຄືນ
            </Button>
          </div>
        </div>

        <QueryState
          result={result}
          title="ກຳລັງໂຫຼດຫ້ອງຮຽນ"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!room ? null : (
            <div className="mt-6 rounded-xl border bg-card p-6">
              <RoomForm
                initialValues={{
                  name: room.name,
                  capacity: room.capacity ?? undefined,
                  description: room.description || "",
                  status: room.status,
                }}
                onSubmit={async (vals) => {
                  try {
                    await updateRoom.mutateAsync(vals);
                    toast.success("ແກ້ໄຂຫ້ອງຮຽນສຳເລັດ", {
                      description: "ຫ້ອງຮຽນຖືກອັບເດດສຳເລັດແລ້ວ",
                    });
                    nav({ to: "/app/master/rooms" });
                  } catch (error) {
                    // Error handling is done by the mutation
                  }
                }}
                submitting={updateRoom.isPending}
              />
            </div>
          )}
        </QueryState>
      </Main>
    </>
  );
}
